const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const $ = (selector, scope = document) => scope.querySelector(selector);

const thumbs = $$(".thumb");
let activeSlide = 0;
function setActiveSlide(index) {
  if (!thumbs.length) return;
  activeSlide = (index + thumbs.length) % thumbs.length;
  const thumb = thumbs[activeSlide];
  const heroImage = $("#hero-image");
  const thumbnailImage = $("img", thumb);
  if (heroImage) {
    heroImage.src = thumb.dataset.src;
    heroImage.alt = thumbnailImage?.alt || "Bettrbio product image";
  }
  thumbs.forEach((item, itemIndex) => {
    const isActive = itemIndex === activeSlide;
    item.classList.toggle("active", isActive);
    if (isActive) item.setAttribute("aria-current", "true");
    else item.removeAttribute("aria-current");
  });
}
thumbs.forEach((thumb, index) => thumb.addEventListener("click", () => setActiveSlide(index)));
$(".nutrition-button")?.addEventListener("click", () => {
  const factsIndex = thumbs.findIndex(
    (thumb) => thumb.dataset.galleryRole === "formula-details",
  );
  if (factsIndex >= 0) setActiveSlide(factsIndex);
});
$(".gallery-arrow.prev")?.addEventListener("click", () => setActiveSlide(activeSlide - 1));
$(".gallery-arrow.next")?.addEventListener("click", () => setActiveSlide(activeSlide + 1));
setActiveSlide(0);

const formatMoney = (cents) => `$${(cents / 100).toFixed(2)}`;
const routineInputs = $$("input[name='routine']");
const routineFromInput = (input) => {
  const option = input.closest("[data-routine-option]");
  return Object.freeze({
    months: Number(option?.dataset.months || 0),
    units: Number(option?.dataset.units || 1),
    totalCents: Number(option?.dataset.totalCents || 0),
    renewalCents: Number(option?.dataset.renewalCents || 0),
    cadence: Number(option?.dataset.cadenceDays || 0),
    cartCount: Number(option?.dataset.cartCount || 1),
    shopifyQuantity: Number(option?.dataset.shopifyQuantity || 1),
    quantityLabel: option?.dataset.quantityLabel || "1 unit",
    plan: option?.dataset.plan || "One-Time Purchase",
  });
};
const ROUTINES = Object.freeze(Object.fromEntries(routineInputs.map((input) => [input.value, routineFromInput(input)])));
const defaultRoutine = $("[data-routine-picker]")?.dataset.defaultRoutine || routineInputs[0]?.value;
const oneTimeInput = $("input[name='routine'][value='once']");
const oneTimeOption = oneTimeInput?.closest("[data-one-time-option]");
let activeSubscriptionValue = $("input[name='routine']:checked:not([value='once'])")?.value || defaultRoutine;
const selectedRoutine = () => {
  const input = $("input[name='routine']:checked") || $(`input[name='routine'][value='${defaultRoutine}']`);
  return input ? routineFromInput(input) : ROUTINES[defaultRoutine];
};
function syncOneTimeOption(subscriptionInput) {
  const source = subscriptionInput?.closest("[data-routine-option]");
  if (!source || !oneTimeOption) return;
  const units = Math.max(1, Number(source.dataset.units || 1));
  const oneTimeUnitCents = Math.max(0, Number(oneTimeOption.dataset.oneTimeUnitCents || 0));
  const physicalItemsPerUnit = Math.max(1, Number(oneTimeOption.dataset.physicalItemsPerUnit || 1));
  const quantityNoun = oneTimeOption.dataset.quantityNoun || "unit";
  const quantityLabel = `${units} ${quantityNoun}${units === 1 ? "" : "s"}`;
  oneTimeOption.dataset.units = String(units);
  oneTimeOption.dataset.totalCents = String(oneTimeUnitCents * units);
  oneTimeOption.dataset.cartCount = String(physicalItemsPerUnit * units);
  oneTimeOption.dataset.shopifyQuantity = String(units);
  oneTimeOption.dataset.quantityLabel = quantityLabel;
  oneTimeOption.dataset.plan = `One-Time Purchase · ${quantityLabel}`;
  const label = $("span", oneTimeOption);
  if (label) label.textContent = `Buy once for ${formatMoney(oneTimeUnitCents * units)} →`;
}

function updatePurchase() {
  if ($("[data-bbgm-bundle-buybox]")) return;
  const routine = selectedRoutine();
  if (!routine) return;
  const total = formatMoney(routine.totalCents);
  const monthly = routine.months ? formatMoney(Math.round(routine.totalCents / routine.months)) : total;
  $("#display-price").textContent = routine.months ? `${monthly}/mo` : total;
  $("#charged-today").textContent = routine.months ? `${total} charged today` : `${routine.quantityLabel} · no renewal`;
  $("[data-routine-cta]").textContent = routine.months
    ? (routine.plan === "Monthly Subscribe & Save" ? `SUBSCRIBE & SAVE — ${total}` : `START MY ${routine.months}-MONTH ROUTINE — ${total}`)
    : `BUY ONCE — ${total}`;
  $("[data-renewal-disclosure]").textContent = routine.months
    ? `Renews at ${formatMoney(routine.renewalCents)} every ${routine.cadence} days. Pause, skip, or cancel anytime.`
    : `${routine.quantityLabel}. No subscription or automatic renewal.`;
  $("#sticky-price").textContent = total;
  $("#sticky-plan").textContent = routine.plan;
  $$(".routine-card").forEach((card) => card.classList.toggle("selected", card.contains($(`input[name='routine'][value='${activeSubscriptionValue}']`))));
}
routineInputs.forEach((input) => input.addEventListener("change", () => {
  if (input.value !== "once") {
    activeSubscriptionValue = input.value;
    syncOneTimeOption(input);
  }
  updatePurchase();
}));
syncOneTimeOption($("input[name='routine']:checked:not([value='once'])") || $(`input[name='routine'][value='${defaultRoutine}']`));

const cart = $(".cart-drawer");
const scrim = $(".scrim");
let returnFocus = null;
function setPageInert(inert) {
  [$("header"), $("main"), $("footer"), $(".mobile-sticky")].forEach((node) => { if (node) node.inert = inert; });
}
function openCart() {
  if (!cart) return;
  returnFocus = document.activeElement;
  cart.hidden = false;
  if (scrim) scrim.hidden = false;
  requestAnimationFrame(() => cart.classList.add("open"));
  cart.setAttribute("aria-hidden", "false");
  setPageInert(true);
  $(".cart-close")?.focus();
}
window.bettrbioOpenCart = openCart;
function closeCart() {
  if (!cart || cart.hidden) return;
  cart.classList.remove("open");
  cart.setAttribute("aria-hidden", "true");
  if (scrim) scrim.hidden = true;
  setPageInert(false);
  window.setTimeout(() => { cart.hidden = true; returnFocus?.focus(); }, 300);
}
window.bettrbioCloseCart = closeCart;
function addSelectedRoutineToCart() {
  const routine = selectedRoutine();
  if (!routine) return;
  $(".cart-empty").hidden = true;
  $(".cart-item").hidden = false;
  $(".checkout").hidden = false;
  $(".cart-variant").textContent = routine.months
    ? `${routine.plan} / Renews every ${routine.cadence} days`
    : `One-Time Purchase / ${routine.quantityLabel}`;
  $(".cart-price").textContent = formatMoney(routine.totalCents);
  $(".cart-button span").textContent = String(routine.cartCount);
  $(".cart-button").setAttribute("aria-label", `Cart, ${routine.cartCount} items`);
  openCart();
}
$(".add-to-cart")?.addEventListener("click", addSelectedRoutineToCart);
$("[data-sticky-routine]")?.addEventListener("click", addSelectedRoutineToCart);

const primaryRoutineAction = $("[data-routine-cta]");
const mobileSticky = $(".mobile-sticky");
if (primaryRoutineAction && mobileSticky && "IntersectionObserver" in window) {
  const observer = new IntersectionObserver(([entry]) => mobileSticky.classList.toggle("is-hidden", entry.isIntersecting), { threshold: .15 });
  observer.observe(primaryRoutineAction);
}
$(".cart-button")?.addEventListener("click", openCart);
$(".cart-close")?.addEventListener("click", closeCart);
scrim?.addEventListener("click", closeCart);
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeCart();
  if (event.key !== "Tab" || !cart || cart.hidden) return;
  const focusable = $$("button, a[href], input, select, textarea, [tabindex]:not([tabindex='-1'])", cart)
    .filter((node) => !node.hidden && !node.disabled);
  const first = focusable[0];
  const last = focusable.at(-1);
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
});

$$(".filter-row button").forEach((button) => button.addEventListener("click", () => {
  $$(".filter-row button").forEach((item) => item.classList.remove("active"));
  button.classList.add("active");
  const filter = button.dataset.filter;
  $$(".review-grid article").forEach((card) => {
    const categories = card.dataset.category?.split(/\s+/) || [];
    card.hidden = filter !== "all" && !categories.includes(filter);
  });
}));

$(".ingredient-toggle")?.addEventListener("click", (event) => {
  const grid = $(".ingredient-grid");
  grid?.classList.toggle("show-all");
  event.currentTarget.textContent = grid?.classList.contains("show-all") ? "SHOW FEWER INGREDIENTS" : "VIEW ALL INGREDIENTS";
});

$$(".faq-list button").forEach((button) => button.addEventListener("click", () => {
  const open = button.getAttribute("aria-expanded") === "true";
  button.setAttribute("aria-expanded", String(!open));
  if (button.lastElementChild) button.lastElementChild.textContent = open ? "+" : "−";
  if (button.nextElementSibling) button.nextElementSibling.hidden = open;
}));

const proofStories = $$(".proof-story");
const proofControls = $$(".proof-story-controls button");
const proofCounter = $(".proof-story-controls span");
let activeProofStory = 0;
function setActiveProofStory(index) {
  if (!proofStories.length) return;
  activeProofStory = (index + proofStories.length) % proofStories.length;
  proofStories.forEach((story, storyIndex) => {
    story.classList.toggle("is-active", storyIndex === activeProofStory);
  });
  if (proofCounter) proofCounter.textContent = `${String(activeProofStory + 1).padStart(2, "0")} / ${String(proofStories.length).padStart(2, "0")}`;
}
proofControls[0]?.addEventListener("click", () => setActiveProofStory(activeProofStory - 1));
proofControls[1]?.addEventListener("click", () => setActiveProofStory(activeProofStory + 1));
setActiveProofStory(0);

const menuButton = $(".menu-button");
menuButton?.addEventListener("click", () => {
  const nav = $(".mobile-nav");
  const open = menuButton.getAttribute("aria-expanded") === "true";
  menuButton.setAttribute("aria-expanded", String(!open));
  if (nav) nav.hidden = open;
});
$$(".mobile-nav a").forEach((link) => link.addEventListener("click", () => {
  const nav = $(".mobile-nav");
  if (nav) nav.hidden = true;
  menuButton?.setAttribute("aria-expanded", "false");
}));

updatePurchase();
document.documentElement.dataset.appReady = "true";

(() => {
  const roots = document.querySelectorAll("[data-bbgm-product]");
  roots.forEach((root) => {
    if (root.querySelector("[data-bbgm-bundle-buybox]")) return;
    const config = root.querySelector(".bbgm-shopify-config");
    const buttons = [...root.querySelectorAll(".add-to-cart, [data-sticky-routine]")];
    const status = root.querySelector(".bbgm-cart-status");
    if (!config || !buttons.length) return;
    const variantId = Number(config.dataset.variantId || 0);
    const planOptions = [...config.querySelectorAll("[data-selling-plan-option]")].map((node) => ({
      id: Number(node.dataset.planId || 0),
      name: node.dataset.planName || "",
      price: Number(node.dataset.planPrice || 0),
    }));
    const routineInputs = [...root.querySelectorAll('input[name="routine"]')];
    const oneTime = root.querySelector('input[name="routine"][value="once"]');
    const routineOption = (input) => input?.closest("[data-routine-option]");
    const findMatchingPlan = (option) => {
      if (!option || Number(option.dataset.months || 0) === 0) return null;
      const cadenceDays = Number(option.dataset.cadenceDays || 0);
      const months = Number(option.dataset.months || 0);
      return planOptions.find((plan) => {
        const name = plan.name.toLowerCase();
        return new RegExp("\\b" + cadenceDays + "\\s*days?\\b", "i").test(name)
          || new RegExp("\\b" + months + "\\s*months?\\b", "i").test(name);
      }) || null;
    };
    for (const input of routineInputs.filter((candidate) => candidate.value !== "once")) {
      const option = routineOption(input);
      const matchingPlan = findMatchingPlan(option);
      if (!matchingPlan) {
        input.disabled = true;
        option?.setAttribute("aria-disabled", "true");
      }
    }
    const selectedSubscription = root.querySelector('input[name="routine"]:checked:not([value="once"])');
    if (selectedSubscription?.disabled && oneTime) {
      selectedSubscription.checked = false;
      oneTime.checked = true;
      oneTime.dispatchEvent(new Event("change", { bubbles: true }));
      if (status) status.textContent = "No exact subscription cadence is available yet. One-time purchase is selected.";
    }
    const addToShopifyCart = async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!variantId) { if (status) status.textContent = "This product is not available yet."; return; }
      const selectedInput = root.querySelector('input[name="routine"]:checked');
      const option = routineOption(selectedInput);
      if (!selectedInput || !option) return;
      const wantsSubscription = selectedInput.value !== "once";
      const matchingPlan = wantsSubscription ? findMatchingPlan(option) : null;
      if (wantsSubscription && !matchingPlan) {
        if (status) status.textContent = "No exact subscription cadence is available. Choose one-time purchase.";
        return;
      }
      const quantity = Math.max(1, Number(option.dataset.shopifyQuantity || 1));
      const hiddenQuantity = root.querySelector('.bbgm-native-product-form input[name="quantity"]');
      if (hiddenQuantity) hiddenQuantity.value = String(quantity);
      const item = { id: variantId, quantity };
      if (matchingPlan) item.selling_plan = matchingPlan.id;
      buttons.forEach((button) => { button.disabled = true; });
      if (status) status.textContent = "Adding to cart…";
      try {
        const response = await fetch(config.dataset.cartAddUrl || window.routes?.cart_add_url || "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [item] }),
        });
        if (!response.ok) throw new Error("Cart request failed with status " + response.status);
        const payload = await response.json();
        const addedItem = payload.items?.[0] || payload;
        if (status) status.textContent = "Added to cart.";
        const count = root.querySelector(".cart-button span");
        if (count) count.textContent = String(quantity);
        const drawer = root.querySelector(".cart-drawer");
        if (drawer) {
          const empty = drawer.querySelector(".cart-empty");
          const cartItem = drawer.querySelector(".cart-item");
          const checkout = drawer.querySelector(".checkout");
          const cartVariant = drawer.querySelector(".cart-variant");
          const cartPrice = drawer.querySelector(".cart-price");
          const linePrice = Number(addedItem.final_line_price ?? (addedItem.final_price || 0) * quantity);
          const currency = window.Shopify?.currency?.active || "USD";
          if (empty) empty.hidden = true;
          if (cartItem) cartItem.hidden = false;
          if (checkout) {
            checkout.hidden = false;
            checkout.addEventListener("click", () => window.location.assign(config.dataset.cartUrl || "/cart"), { once: true });
          }
          if (cartVariant) cartVariant.textContent = (matchingPlan ? option.dataset.plan : "One-time purchase") + " / Qty " + quantity;
          if (cartPrice) cartPrice.textContent = new Intl.NumberFormat(undefined, { style: "currency", currency }).format(linePrice / 100);
          if (typeof window.bettrbioOpenCart === "function") {
            window.bettrbioOpenCart();
          } else {
            const scrim = root.querySelector(".scrim");
            drawer.hidden = false;
            if (scrim) scrim.hidden = false;
            drawer.setAttribute("aria-hidden", "false");
            drawer.classList.add("open");
            [root.querySelector("header"), root.querySelector("main"), document.querySelector("footer"), root.querySelector(".mobile-sticky")]
              .forEach((node) => { if (node) node.inert = true; });
            drawer.querySelector(".cart-close")?.focus();
          }
        }
      } catch (error) {
        if (status) status.textContent = "We couldn't add that to your cart. Please try again.";
      } finally {
        buttons.forEach((button) => { button.disabled = false; });
      }
    };
    buttons.forEach((button) => button.addEventListener("click", addToShopifyCart, true));
  });
})();
